export const assetTypeIcon = (type: string): string => ({
    server: "mdi-server",
    switch: "mdi-switch",
    router: "mdi-router-network",
    ups: "mdi-battery-charging",
    generator: "mdi-engine",
    cooling: "mdi-air-conditioner",
    pdu: "mdi-power-plug",
    storage: "mdi-database",
    disk: "mdi-harddisk",
    internet_circuit: "mdi-access-point-network",
    customer_network: "mdi-lan",
    managed_vm: "mdi-cloud-outline",
    computer: "mdi-desktop-tower-monitor",
    rack: "mdi-server-network",
    location: "mdi-map-marker-outline",
    datacenter: "mdi-office-building-marker-outline",
    other: "mdi-cube-outline",
}[type] ?? "mdi-cube-outline");
